import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconOverlay2Column = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M4 2.667h9.714c.736 0 1.333.597 1.333 1.333v4.783c0 .736-.597 1.333-1.333 1.333H4a1.333 1.333 0 0 1-1.333-1.333V4c0-.736.597-1.333 1.333-1.333zm0 9.77h9.714c.736 0 1.333.597 1.333 1.333v4.783c0 .736-.597 1.333-1.333 1.333H4a1.333 1.333 0 0 1-1.333-1.333V13.77c0-.736.597-1.333 1.333-1.333zm0 9.771h9.714c.736 0 1.333.597 1.333 1.333V28c0 .736-.597 1.333-1.333 1.333H4A1.333 1.333 0 0 1 2.667 28v-4.459c0-.736.597-1.333 1.333-1.333zM18.287 2.667h9.714c.736 0 1.333.597 1.333 1.333v4.783c0 .736-.597 1.333-1.333 1.333h-9.714a1.333 1.333 0 0 1-1.333-1.333V4c0-.736.597-1.333 1.333-1.333zm0 9.77h9.714c.736 0 1.333.597 1.333 1.333v4.783c0 .736-.597 1.333-1.333 1.333h-9.714a1.333 1.333 0 0 1-1.333-1.333V13.77c0-.736.597-1.333 1.333-1.333zm0 9.771h9.714c.736 0 1.333.597 1.333 1.333V28c0 .736-.597 1.333-1.333 1.333h-9.714A1.333 1.333 0 0 1 16.954 28v-4.459c0-.736.597-1.333 1.333-1.333z"
	})
});
export { SvgIconOverlay2Column as ReactComponent };
